import { FilterOperator } from "./filter-operator.enum";
import { Condition } from "./condition.model";


export class ColumnFilter {
    public columnName: string;
    public conditions: Array<Condition>;
    public flterColumnOperator: FilterOperator;
}
